import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_HOLIDAY, ADD_HOLIDAY_FAILED, ADD_HOLIDAY_SUCCESS, HOLIDAY, HOLIDAY_FAILED, HOLIDAY_SUCCESS, UPDATE_HOLIDAY, UPDATE_HOLIDAY_FAILED, UPDATE_HOLIDAY_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getHolidays = () => async (dispatch) => {
  dispatch({
    type: HOLIDAY,
  });
  try {
    let response = await api(`holiday/holidayList`, "get", {}, getAuthHeader());
    dispatch({
      type: HOLIDAY_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Holiday list error ====>", error);
    return dispatch({
      type: HOLIDAY_FAILED,
      payload: error?.message,
    });
  }
};

export const addHoliday = (data) => async dispatch => {
  dispatch({
    type: ADD_HOLIDAY
  })
  try {
    let response = await api(`holiday/add`, 'post', data, getAuthHeader())
    console.log('add holiday data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_HOLIDAY_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while Adding holiday error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_HOLIDAY_FAILED,
      payload: error?.message
    })
  }
}

export const updateHoliday = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_HOLIDAY
  })
  try {
    let response = await api(`holiday/update/${id}`, 'put', data, getAuthHeader())
    console.log('update holiday data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_HOLIDAY_SUCCESS,
      payload: response?.data
    })
    return response
  } catch (error) {
    console.log("while updating holiday error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_HOLIDAY_FAILED,
      payload: error?.message
    })
  }
}